<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense dark elevation="0" color="primary">
                    <v-list-item-title>
                        <!-- <v-icon>mdi-eye-circle</v-icon> -->
                        <span>{{title}}</span>
                    </v-list-item-title>
                    <TitleButton
                        icon="mdi-floppy"
                        :name="work"
                        @click="onClickSave()" />
                    <TitleButton
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-form ref="form">
                        <v-row >
                            <v-col>
                                <DatePicker 
                                    label="作業日"
                                    dense
                                    v-model="editItems.date" />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col v-if="mode != 99">
                                <v-select 
                                    v-model="editItems.state" 
                                    label="状態" 
                                    outlined
                                    clearable
                                    :items="states" 
                                    item-text="text" 
                                    item-value="value" 
                                    prepend-icon="mdi-state-machine"
                                    hint="選択された全ての収穫物の状態を同じ状態に設定する時は、選択して下さい。"
                                    persistent-hint/>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <PlaceSelector v-if="places != null && places.length > 0" v-model="editItems.placeID" :places="places" :placeGroups="placeGroups"/>
                            </v-col>
                            <v-col>
                                <v-text-field v-if="places == null || editItems.placeID == null || editItems.placeID == undefined" v-model="editItems.placeName" dense clearable label="新しい場所" item-text="text" outlined hint="登録されていない場所の時は、ここに入力します。" persistent-hint />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import PlaceSelector from '@/components/seedling/items/SelectorPlace';
    import DatePicker from '@/components/tools/DatePicker';
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            PlaceSelector,
            DatePicker,
            TitleButton,
            Confirm
        },
        props: {
            places: {
                type: Array,
                default: null
            },
            placeGroups: {
                type: Array,
                default: null
            },
            harvests: {
                type: Array,
                default: null
            }
        },
        computed: {
            title: function () {
                switch (this.mode) {
                    case 2: return "収穫物の移動"
                    case 99: return "収穫物の廃棄"
                }
            },
            work: function () {
                switch (this.mode) {
                    case 2: return "移動"
                    case 99: return "廃棄"
                }
            }
        },
        data: function () {
            return {
                mode: 0,    // 2:移動,99:廃棄
                isView: false,
                editItems: {
                    date: this.df_currentDateTime("yyyy-MM-dd"),
                    placeID: null,
                    placeName: "",
                    state: null
                },
                states: [
                    {value: 10, text:"観察"},
                    {value: 20, text:"出荷"},
                ],
            }
        },
        created: function () {
            console.log("created")
        },
        methods: {
            onClickSave: function () {
                console.log("onClickSave", this.editItems)

                if (this.editItems.placeID == null && this.editItems.placeName.length == 0) {
                    this.$refs.confirm.show({
                        title: "入力エラー",
                        message: "場所を選択するか、新しい場所を入力して下さい。",
                        width: 400,
                        buttonYes: "入力に戻る",
                        buttonNo: "",
                    })
                    return
                }

                const self = this
                var title = ""
                var message = ""
                var buttonCaption = ""

                switch (this.mode) {
                    case 2:
                        title = "移動"
                        message = "収穫物を選択された場所に移動しますか？"
                        buttonCaption = "移動する"
                        break
                    case 99:
                        title = "廃棄"
                        message = "収穫物を選択された場所に廃棄しますか？<br/>※廃棄した収穫物は、観察など一切の作業が行えなくなります。"
                        buttonCaption = "廃棄する"
                        break
                }

                this.$refs.confirm.show({
                    title: title,
                    message: message,
                    buttonYes: buttonCaption,
                    buttonNo: "いいえ",
                    width: 600,
                    listenerYes: function () {
                        self.register()
                        return true
                    },
                })
            },
            register: function () {
                console.log("register", this.editItems)

                const userUID = this.$store.getters["userUID"]
                const self = this

                // 場所が未選択で、かつ手入力されている時
                var newPlace = null
                if (this.editItems.placeID == null && this.editItems.placeName.length > 0) {
                    var newPlaceID = 1
                    if (this.places != null && this.places.length > 0) {
                        newPlaceID = Math.max(...this.places.map(m => m.placeID)) + 1
                    }
                    newPlace = {
                        // version: "1.0.0",
                        // placeID: newPlaceID,
                        // name: this.editItems.placeName,
                        // register: {
                        //     userUID: userUID,
                        //     dateTime: this.df_currentDateTime()
                        // },
                        // updater: {
                        //     userUID: "",
                        //     dateTime: ""
                        // }
                        version: "1.0.0",
                        placeID: newPlaceID,
                        cultivationType: null,
                        name: this.editItems.placeName,
                        details: {
                            area: 0,
                            variety: {
                                cropID: 1,
                                varietyID: 1
                            }
                        },
                        address: {
                            postalCode: "",
                            pref: "",
                            city: "",
                            address1: "",
                            address2: "",
                            areaID: ""
                        },
                        placeGroupID: "",
                        isDeleted: false,
                        streamingURLs: [],
                        image: null,
                        groupUserAuthorities: ["browse", "work", "environment"],
                        managementAgrichemical: {
                            enabled: false,
                            target: null,
                            dateTime: "",
                            startDate: {
                                month: 1,
                                day: 1
                            },
                        },
                        memo: "",
                        register: {
                            userUID: userUID,
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        },
                    }
                    this.editItems.placeID = newPlaceID
                }

                // 登録処理開始
                try {
                    var batch = db.batch()

                    for (var i=0; i<this.harvests.length; i++) {
                        const harvest = this.harvests[i].body.body
                        const seedling = this.harvests[i].seedling.body
                        harvest.currentPlace = this.editItems.placeID
                        harvest.updater.userUID = userUID
                        harvest.updater.dateTime = this.df_currentDateTime()
                        const history = {
                            type: 99,
                            place: this.editItems.placeID,
                            date: this.editItems.date,
                            dateTime: this.df_currentDateTime(),
                            userUID: userUID
                        }
                        harvest.placeHistories.push(history)
                        switch (this.mode) {
                            case 99:
                                harvest.state = 99
                                break;
                            default:
                                if (this.editItems.state != undefined && this.editItems.state != null) {
                                    harvest.state = this.editItems.state
                                }
                                break;
                        }
                        batch.update(db.collection("users").doc(userUID).collection("seedlings").doc(seedling.seedlingID).collection("harvests").doc(""+harvest.harvestNo), harvest)
                    }

                    // 場所
                    if (newPlace != null) {
                        batch.set(db.collection("users").doc(userUID).collection("places").doc(""+newPlace.placeID), newPlace)
                        this.$store.commit(
                            "managementItems/addUserPlace",
                            {
                                userUID: userUID,
                                placeData: this.$store.getters["managementItems/loggedInUserPlaceData"], 
                                place: newPlace
                            }
                        )
                    }

                    // コミット
                    batch.commit().then(function(){
                        self.$store.commit("notification", {message:"収穫物の"+self.work+"を行いました。"})
                        if (newPlace != null) {
                            self.$emit("onRegisteredNewPlace", newPlace)
                        }
                        self.isView = false
                    }).catch(function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"収穫物の"+self.work+"に失敗しました。", isError:true})
                    })

                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"苗の"+self.work+"に失敗しました。", isError:true})
                }
            },
            show: function (mode) {
                this.mode = mode

                this.editItems.date = this.df_currentDateTime("yyyy-MM-dd"),
                this.editItems.placeID = null
                this.editItems.placeName = ""
                this.editItems.state = null

                this.isView = true
            }
        }
    }
</script>
